import {
  dataSourcesActionCreators,
  dataSourcesStardogRequestDispatchers,
} from 'src/actions/data-sources/actionCreators';
import { DataSourcesActionType } from 'src/actions/data-sources/actionTypes';
import { connectionSelector } from 'src/selectors/connection';
import { isStardogFeatureSupportedSelector } from 'src/selectors/isStardogFeatureSupported';
import { SqlDataSource } from 'src/store/state/dataSources';
import { AppDispatch } from 'src/store/store';
import { ReduxStateGetter } from 'src/store/types';

export const addDataSource =
  (newDataSource: SqlDataSource) =>
  async (dispatch: AppDispatch, getState: ReduxStateGetter) => {
    const state = getState();
    const connection = connectionSelector(state);
    const isCatalogSupported = isStardogFeatureSupportedSelector(
      'isCatalogSupported',
      connection
    )(state);
    const isDataSourceMetadataRefreshSupported =
      isStardogFeatureSupportedSelector(
        'isDataSourceAutomaticMetadataRefreshSupported',
        connection
      )(state);
    const isDataSourceTablesEndpointSupported =
      isStardogFeatureSupportedSelector(
        'isDataSourceTablesEndpointSupported',
        connection
      )(state);

    if (!connection) {
      return false;
    }

    dispatch(dataSourcesActionCreators.addDataSourceStarted());

    const addDataSourceResponse =
      await dataSourcesStardogRequestDispatchers.addDataSource(newDataSource);

    if (
      addDataSourceResponse.type ===
      DataSourcesActionType.ADD_DATA_SOURCE_FAILURE
    ) {
      dispatch(dataSourcesActionCreators.addDataSourceFinished());
      return false;
    }
    if (!isDataSourceMetadataRefreshSupported) {
      await dataSourcesStardogRequestDispatchers.refreshDataSourceTypeMetadata(
        newDataSource.id,
        connection
      );
    }
    await dataSourcesStardogRequestDispatchers.requestDataSourceOptions(
      newDataSource.id,
      connection
    );

    if (!isDataSourceTablesEndpointSupported) {
      await dataSourcesStardogRequestDispatchers.requestDataSourceTableMetadata(
        newDataSource.id,
        isCatalogSupported
      );
    } else {
      await dataSourcesStardogRequestDispatchers.requestDataSourceTables(
        newDataSource.id,
        isCatalogSupported
      );
    }

    dispatch(dataSourcesActionCreators.addDataSourceFinished());
    return true;
  };
